import {
	tenantStackCheckPoll,
	tenantStackCheckPollRejected,
	tenantStackCheckPollResolved,
	tenantStackCheckPollStop,
	tenantStackCheckPollTimeout,
	tenantStackCreate,
	tenantStackCreateRejected,
	tenantStackCreateResolved,
} from '@Actions/tenantStack';
import { createReducer } from '@reduxjs/toolkit';
import { TenantStackStoreState } from '@Types/tenatStack';

export const initialState: TenantStackStoreState = {
	create: { initialized: false, status: 'idle' },
	check: { initialized: false, status: 'idle', stackExists: false },
};

const reducer = createReducer(initialState, builder =>
	builder
		// * create - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
		.addCase(tenantStackCreate, state => {
			state.create.status = 'pending';
			state.create.initialized = false;
		})
		.addCase(tenantStackCreateResolved, state => {
			state.create.status = 'completed';
			state.create.initialized = true;
		})
		.addCase(tenantStackCreateRejected, state => {
			state.create.status = 'rejected';
			state.create.initialized = true;
		})
		// * check poll - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
		.addCase(tenantStackCheckPoll, state => {
			state.check.status = 'pending';
			state.check.initialized = false;
		})
		.addCase(tenantStackCheckPollResolved, (state, { payload }) => {
			state.check.status = 'completed';
			state.check.initialized = true;
			state.check.stackExists = payload.stackExists;
		})
		.addCase(tenantStackCheckPollRejected, state => {
			state.check.status = 'rejected';
			state.check.initialized = true;
		})
		.addCase(tenantStackCheckPollStop, state => {
			state.check.status = 'idle';
			state.check.initialized = true;
		})
		.addCase(tenantStackCheckPollTimeout, state => {
			state.check.status = 'rejected';
			state.check.initialized = true;
		}),
);

export default reducer;
